<template>
  <div class="main">
    <div v-for="(item, index) of list" :key="index" class="publish">
      <div class="store">
        <van-image
            class="img"
            fit="cover"
            :src="item.showImg || require('@/imgs/place.png')"
        />
        <!--<div class="modify delete" @click="deleteIt(item.publishId)">-->
        <!--<img src="@/imgs/delete.png">-->
        <!--<p>删除</p>-->
        <!--</div>-->
        <div class="modify" @click="goToEdit(item.publishId)">
          <img src="@/imgs/modify.png">
          <p>修改</p>
        </div>
        <div class="store-info">
          <h1>
            {{ item.title }}
          </h1>
          <h2>
            {{
              item.contact || '匿名用户'
            }}<span>{{ item.phone ? handlePhone(item.phone) : '' }}</span>
          </h2>
          <h4>
            {{ item.acreage || '面议' }}㎡
            <span>{{ item.rent || '面议' }}</span>
            <p>元/月</p>
          </h4>
        </div>
      </div>
      <div v-if="item.publishStatus === '0'" class="info">
        <h1 class="title" v-if="!hasPay">
          <p>已筛选出{{ item.personList.length }}位找店用户，</p>
          <span>支付后立即匹配推送</span>
        </h1>
        <div class="list" v-if="!hasPay">
          <div v-for="(person, i) of item.personList" :key="i" class="user">
            <h1>{{ person.personName }}</h1>
            <div>
              <img class="position" src="@/imgs/location.png">
              <p>{{ person.cityName }}</p>
            </div>
            <div>
              <img class="phone" src="@/imgs/telephone.png">
              <p>
                {{ person.personPhone ? handlePhone(person.personPhone, true) : '' }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
          v-if="item.publishStatus === '0' && !hasPay"
          class="payBtn"
          @click="goToPay(item.publishId)"
      >
        立即支付
      </div>
    </div>
  </div>
</template>

<script>
import {headers, handlePhone} from '@/utils/util'
import {myPublish, deletePublish} from '@/api/api'

export default {
  name: 'Published',
  data() {
    return {
      list: [],
      hasPay: false
    }
  },
  created() {
  },
  mounted() {
    this.getMyPublish()
  },
  methods: {
    goToEdit(publishId) {
      this.$router.push({
        path: 'publish',
        query: {
          publishId
        }
      })
    },
    handlePhone(phone, isHide) {
      return handlePhone(phone, isHide)
    },
    async getMyPublish() {
      const form = {
        page: 1,
        limit: 100
      }
      const res = await myPublish(headers(form), form)
      this.list = res.data
      const payList = res.data.filter((s) => {
        return s.publishStatus === '2'
      })
      if (payList.length > 0) {
        this.hasPay = true
      }
    },
    async deleteIt(publishId) {
      const res = await deletePublish(headers({publishId}), {publishId})
      this.$notify({type: 'success', message: res.msg})
      this.getMyPublish()
    },
    async goToPay(publishId) {
      await this.$store.dispatch('setPublishId', publishId)
      this.$router.push('/pay')
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  padding: 30px;

  .publish {
    overflow: hidden;
    margin-bottom: 30px;
    padding: 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 20px 0px rgba(179, 179, 179, 0.2);
    border-radius: 12px;

    .store {
      display: flex;
      flex-direction: row;
      position: relative;

      .modify {
        position: absolute;
        bottom: 9px;
        right: 0;
        width: 106px;
        height: 40px;
        background: rgba(253, 106, 66, 1);
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          margin-right: 8px;
          width: 21px;
          height: 20px;
        }

        p {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 800;
          color: rgba(255, 255, 255, 1);
        }
      }

      .delete {
        bottom: 80px;
        background: #547bdf;
      }

      .img {
        margin-right: 20px;
        width: 200px;
        height: 150px;
        border-radius: 6px;
        overflow: hidden;
      }

      .store-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 19px 0;
        overflow: hidden;
        justify-content: space-between;

        h1 {
          line-height: 28px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 800;
          color: rgba(51, 51, 51, 1);
        }

        h2 {
          display: flex;
          font-size: 20px;
          line-height: 20px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(153, 153, 153, 1);

          span {
            margin-left: 31px;
          }
        }

        h4 {
          display: flex;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 500;
          color: rgba(102, 102, 102, 1);

          span {
            margin: 0 10px 0 30px;
            line-height: 32px;
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: 800;
            color: rgba(248, 66, 66, 1);
          }

          p {
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(248, 66, 66, 1);
          }
        }
      }
    }

    .info {
      margin-top: 50px;
      padding: 0 63px;

      .title {
        display: flex;
        height: 73px;
        align-items: center;
        flex-wrap: nowrap;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(253, 106, 66, 1);
        border-bottom: 1px solid #f2f2f2;
        justify-content: center;

        p {
          white-space: nowrap;
        }

        span {
          white-space: nowrap;
          width: 330px;
          height: 36px;
          background: rgba(84, 123, 223, 1);
          border-radius: 6px;
          color: #ffffff;
          text-align: center;
          line-height: 36px;
        }
      }

      .list {
        display: flex;
        flex-direction: column;

        .user {
          display: flex;
          height: 86px;
          align-items: center;
          border-bottom: 1px solid #f2f2f2;

          &:last-child {
            border-bottom: none;
          }

          h1 {
            flex: 1;
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 800;
            color: rgba(51, 51, 51, 1);
          }

          div {
            margin-left: 59px;
            display: flex;
            height: 100%;
            line-height: 86px;
            align-items: center;

            .position {
              width: 18px;
            }

            .phone {
              width: 21px;
            }

            p {
              margin-left: 13px;
              font-size: 24px;
              font-family: PingFang SC;
              font-weight: 500;
              color: rgba(153, 153, 153, 1);
            }
          }
        }
      }
    }

    .payBtn {
      margin: 0 0 -20px -20px;
      width: 690px;
      height: 100px;
      background: rgba(253, 106, 66, 1);
      line-height: 100px;
      text-align: center;
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>
